import { t as e } from "./i18n-lite-BcmwMblk.js";
//#region src/webcomponents/common/stepper/locales/de-AT.json
var t = {}, n = {}, r = {}, i = {}, a = {}, o = { stepper: { step: "Étape {{step}} sur {{stepsCount}}" } }, s = {}, c = {};
//#endregion
//#region src/webcomponents/common/stepper/index.js
function l() {
	e.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
		"./locales/de-AT.json": t,
		"./locales/en.json": n,
		"./locales/es-419.json": r,
		"./locales/es.json": i,
		"./locales/fr-BE.json": a,
		"./locales/fr.json": o,
		"./locales/it.json": s,
		"./locales/nl.json": c
	}));
}
//#endregion
export { l as t };
